import {
    PlatformNavbar,
    PlatformNavbarMenuItem,
    PlatformNavbarMode
} from "@flexinet/ui-components";
import {getMenuItems} from "../data/menus.tsx";
import {useVerifiedPermissions} from '@flexinet/auth-components';


export const PortalNavbar = (
    {
        mode,
        changeMode
    }: {
        mode: PlatformNavbarMode,
        changeMode: (mode: PlatformNavbarMode) => void
    }
) => {

    // @see this - https://github.com/aws-amplify/amplify-ui/blob/main/packages/ui/src/types/authenticator/user.ts
    // @see this - https://ui.docs.amplify.aws/react/guides/auth-protected
    // @see this - https://github.com/aws-amplify/amplify-ui/blob/main/guides/react/protected-routes/src/components/Layout.jsj
    // https://ui.docs.amplify.aws/react/connected-components/authenticator


    const {allowedActions} = useVerifiedPermissions()

    // const {pathname} = useLocation()
    // const itemsParent = findParent(pathname)
    // const items = itemsParent?.links ?? []
    const items = getMenuItems()
    const menuItems = items.filter((item: PlatformNavbarMenuItem) => {

        if (item.links) {
            item.links = item.links.filter((child: PlatformNavbarMenuItem) => {
                return allowedActions.includes(child.rbac as string)
            })
        }

        return allowedActions.includes(item.rbac as string)
    });

    return <PlatformNavbar
        appTitle='Flexi Network Portal'
        menuItems={menuItems}
        mode={mode}
        changeMode={changeMode}
    />

};
